<template>
  <div class="time-table-list">
    <collapse v-model="opened" accordion @on-change="changePanel">
      <panel v-for="(project, i) in projects" :key="project.id" :name="`${i}`">
        <time-table-row
          :project="project"
          @change-amendment="updateTable"
          :index="i"
          :opened="opened"
          :ref="`timeTableRow_${i}`"
        />
        <time-table-expand
          slot="content"
          :roadmap="project.roadmap"
          :loading="project.loading"
          :id="project.id"
          :index="i"
          :customer="project.customer"
          @save-roadmap="updateTable"
        />
      </panel>
    </collapse>
  </div>
</template>

<script>
import TimeTableRow from './time-table-row'
import TimeTableExpand from './time-table-expand'
import { formatDefaultDate } from '@/utils'

const changedProps = [
  'code',
  'name',
  'costs',
  'start_date',
  'manager_name',
  'ukii_dates_signed',
  'ukii_expired',
  'acts_dates_signed',
  'acts_expired',
  'payments_dates_signed',
  'payments_expired'
]

export default {
  props: ['projects', 'default-opened'],
  components: {
    TimeTableRow,
    TimeTableExpand
  },
  data () {
    return {
      opened: this.defaultOpened || []
    }
  },
  methods: {
    updateTable ({ index, amendment_id }) {
      this.changePanel([index], amendment_id)
    },
    async changePanel (keys, amendment_id) {
      if (!keys.length) return

      const [index] = keys
      const [row] = this.$refs[`timeTableRow_${index}`]
      const amendment = amendment_id || row.amendment
      if (index === undefined) return

      try {
        this.$set(this.projects[index], 'loading', true)
        let projectUrl = `page/project/${this.projects[index].id}`
        if (amendment) projectUrl += `?amendment_id=${amendment}`
        let roadmapUrl = `page/roadmap?contract_id=${this.projects[index].id}`
        if (amendment) roadmapUrl += `&amendment_id=${amendment}`
        const roadmapData = await this.$store.dispatch('GET_REQUEST', {
          url: roadmapUrl
        })
        const projectData = await this.$store.dispatch('GET_REQUEST', {
          url: projectUrl
        })

        const roadmap = this.modifyRoadmap(roadmapData)

        changedProps.forEach(p =>
          this.$set(this.projects[index], p, projectData[p])
        )
        this.$set(this.projects[index], 'roadmap', roadmap)
        this.$set(this.projects[index], 'loading', false)
      } catch (error) {
        console.log(error)
        this.$set(this.projects[index], 'loading', false)
      }
    },
    modifyRoadmap (roadmap) {
      return roadmap.map(r => ({
        ...r,
        fact_to_reporting_date: r.fact_to_reporting_date
          ? formatDefaultDate(r.fact_to_reporting_date)
          : null,
        fact_to_finalizing_date: r.fact_to_finalizing_date
          ? formatDefaultDate(r.fact_to_finalizing_date)
          : null,
        fact_act_sign_date: r.fact_act_sign_date
          ? formatDefaultDate(r.fact_act_sign_date)
          : null,
        fact_payment_date: r.fact_payment_date
          ? formatDefaultDate(r.fact_payment_date)
          : null
      }))
    }
  },
  mounted () {
    if (this.defaultOpened) {
      this.changePanel(this.defaultOpened)
    }
  }
}
</script>

<style lang="less">
.time-table-list {
  .ivu-collapse {
    &-header {
      display: flex;
      align-items: center;
    }
  }
}

.light {
  .time-table-list {
    .ivu-collapse {
      background-color: rgba(67, 82, 109, 0.04);
    }
  }
}
</style>
